import { Button } from "@/shared/ui/button.tsx";
import { Dialog, DialogContent, DialogTrigger } from "@/shared/ui/dialog.tsx";
import { Copy, Download, Pause, Pencil, Play } from "lucide-react";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  currentImg: string,
  image_id: number,
  media_type: "image" | "video"
  image_video_recommendation: string,
  galleryTrigger: JSX.Element
}

const ImageDialog = ({ currentImg, image_video_recommendation, galleryTrigger, image_id, media_type = "image" }: Props) => {

  const navigate = useNavigate()

  const [play, setPlay] = useState(false)
  const [playInner, setPlayInner] = useState(false)

  const videoRef = useRef<HTMLVideoElement | null>(null)
  const innerVideoRef = useRef<HTMLVideoElement | null>(null)

  return (
    <Dialog>
      <DialogTrigger>
        <div className="size-full relative group">
          {media_type === "video"
            ? <div className="relative group">
              <video
                ref={videoRef}
                className="w-full h-fit rounded-lg cursor-pointer"
                src={currentImg}
                loop muted playsInline
              />
              <span className="absolute top-[50%] left-[50%] z-50 -translate-x-[50%] -translate-y-[50%] opacity-0 group-hover:opacity-100 transition-opacity ease-in-out">
                <Button variant="default" size="icon" className="rounded-full cursor-pointer bg-white/50 text-purple-500 border border-purple-500 size-14 hover:bg-white"
                  onClick={(e) => {
                    e.stopPropagation()
                    if (!play) {
                      videoRef.current?.play()
                      setPlay(true)
                    } else {
                      videoRef.current?.pause()
                      setPlay(false)
                    }
                  }}>
                  {!play ?
                    <Play strokeWidth="2" className="scale-150" />
                    : <Pause strokeWidth="2" className="scale-150" />
                  }
                </Button>
              </span>
            </div>
            : <img
              src={currentImg}
              loading="lazy"
              className="w-full h-fit rounded-lg cursor-pointer"
              alt="Preview"
              width="500px"
              height="500px"
            />}
          <div className="absolute bottom-1 right-1" onClick={e => e.stopPropagation()}>
            {galleryTrigger}
          </div>
        </div>
      </DialogTrigger>
      <DialogContent className="max-w-2xl bg-black text-purple-500 font-semibold border-none outline-black p-0">
        <div className="absolute bottom-2 right-2 flex items-center gap-2">
          <Button size="icon"
            title="Download Image"
            className=""
            onClick={() => {
              const link = document.createElement('a');
              link.href = currentImg;
              link.download = currentImg.split('/').pop() || 'image';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}>
            <Download />
          </Button>
          <Button size="icon"
            onClick={() => {
              navigator.clipboard.writeText(image_video_recommendation)
            }}
          >
            <Copy />
          </Button>
          <Button size="icon"
            onClick={() => {
              navigate(`/home/gallery/${image_id}`)
            }}
          >
            <Pencil />
          </Button>
        </div>
        {media_type === "video"
          ? <div className="relative group">
            <video
              ref={innerVideoRef}
              className="w-full h-fit max-h-[95vh] rounded-lg cursor-pointer"
              src={currentImg}
              loop muted playsInline
            />
            <span className="absolute top-[50%] left-[50%] z-50 -translate-x-[50%] -translate-y-[50%] opacity-0 group-hover:opacity-100 transition-opacity ease-in-out">
              <Button variant="default" size="icon" className="rounded-full cursor-pointer bg-white/50 text-purple-500 border border-purple-500 size-14 hover:bg-white"
                onClick={(e) => {
                  e.stopPropagation()
                  if (!playInner) {
                    innerVideoRef.current?.play()
                    setPlayInner(true)
                  } else {
                    innerVideoRef.current?.pause()
                    setPlayInner(false)
                  }
                }}>
                {!playInner ?
                  <Play strokeWidth="2" className="scale-150" />
                  : <Pause strokeWidth="2" className="scale-150" />
                }
              </Button>
            </span>
          </div>
          : <img
            src={currentImg}
            loading="lazy"
            className="w-full h-fit rounded-lg cursor-pointer"
            alt="Preview"
            width="500px"
            height="500px"
          />}
      </DialogContent>
    </Dialog>
  )
}

export default ImageDialog
